import API from '../api' 

export const getLangList = () => (
    API.get('api/v1/languages?per_page=10&page=1')
)